import { ButtonProps } from 'semantic-ui-react';

import { Button } from './styles';

export function ButtonGDY({ ...rest }: ButtonProps) {
	return <Button {...rest} />;
}
